function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "51",
  height: "40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2)",
  stroke: "#151417",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.435 40.827l-3.01-3.883-2.761-1.738c-2.806.396-9.574.81-14.196-.7-5.777-1.885-3.14-12.072.998-20.228 4.137-8.156 23.409-5.783 31.039-5.407 7.63.376 6.671 12.603 4.893 19.808-1.423 5.764-9.834 7.045-13.862 6.965l-3.101 5.183z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.645 25.147c.022-.444 1.587-4.56 2.366-6.563.73 2.448 2.196 7.233 2.218 6.789.022-.445 2-6.024 2.985-8.758M25.55 26.585c-4.083 2.097-8.765-9.049-2.412-8.735 6.352.313.19 3.839-3.686 5.562M31.017 19.131c-1.384 2.463-3.288 7.43.166 7.6 4.317.213 5.743-6.766 3.505-5.25-2.24 1.517-.4 8.114 1.838 6.598 1.791-1.213 3.136-5.087 3.585-6.872",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .001)",
  d: "M0 0h51v40H0z"
}))));